<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="確認"
  >
    <template v-slot:header="{ cancel }">
      <v-card-title class="screen-title">確認</v-card-title>
      <div class="d-flex flex-row align-start ga-2">
        <template v-if="billingFreeFlg">
          <v-chip size="large" color="info" variant="flat">無料枠</v-chip>
        </template>
        <button
          type="button"
          aria-label="Close"
          class="close ml-5"
          @click="cancel()"
        >
          ×
        </button>
      </div>
    </template>
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="pb-3">
              <strong>
                こちらの内容でクラウド接続向けVN回線を削除します。よろしいですか？
              </strong>
            </v-row>
            <div class="my-3">
              <v-row>
                <!-- 基本設定 -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>基本設定</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="KCPSユーザーID"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon.serviceKey
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="回線番号"
                          :value="cloudVnKcpsDetail.enumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group label="品目">
                          <template #value>
                            <div class="ml-3">
                              {{
                                cloudVnKcpsDetail.cloudVnConnectCommon
                                  .bandwidthType
                              }}({{
                                $filter.bandwidthTo(
                                  cloudVnKcpsDetail.cloudVnConnectCommon
                                    .bandwidth
                                )
                              }})
                            </div>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="ロケーション"
                          :value="
                            $filter.enumTo(
                              cloudVnKcpsDetail.cloudVnConnectCommon.location,
                              'kcpsLocationV2'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="契約番号(M番号)"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon.mNumber
                          "
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <app-label-group
                          label="利用ゾーン"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon.usageZone
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="プライベートLAN ID"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon.privateLanId
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="仮想IPアドレス"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon
                              .virtualIpAddress
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="備考"
                          :value="
                            $filter.emptyTo(
                              cloudVnKcpsDetail.cloudVnConnectCommon
                                .description,
                              '-'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <!--接続先VPN/VN -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>接続先VPN/VN</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VPN/VNコード"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon.vpnVnCode
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="仮想ネットワーク(VN)名"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon.vpnVnCode.startsWith(
                              'B'
                            )
                              ? '-'
                              : cloudVnKcpsDetail.cloudVnConnectCommon.vnName
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="L2/L3"
                          :value="cloudVnKcpsDetail.cloudVnConnectCommon.vnType"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="ルーティング種別"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon.routingType
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="AS番号"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon.asNumber
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="MD5キー"
                          :value="
                            $filter.emptyTo(
                              cloudVnKcpsDetail.cloudVnConnectCommon.md5Key,
                              '-'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="Maximum Prefix"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon.maximumPrefix
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>

              <!-- 広報ルート（独立セクション） -->
              <v-row class="mt-2">
                <v-col cols="12">
                  <h3>広報ルート</h3>
                </v-col>
              </v-row>
              <!--Connectedルート広報-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Connectedルート広報"
                    :value="
                      $filter.enumTo(
                        cloudVnKcpsDetail.cloudVnConnectCommon.publicRelation,
                        'enable'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--BGP 広報ルート(ルート分割)-->
              <v-row>
                <v-col>
                  <app-label-group label="BGP 広報ルート(ルート分割)">
                    <template #value>
                      <div
                        v-if="sortedSplitRouteList.length"
                        class="d-flex flex-wrap address-scroll"
                      >
                        <span
                          class="ml-3"
                          v-for="(item, index) in sortedSplitRouteList"
                          :key="index"
                        >
                          {{ item }}
                        </span>
                      </div>
                      <span v-else class="ml-3">-</span>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>
              <!--BGP 広報ルート(Connected以外) / (Connected以外のネクストホップ)-->
              <v-row class="mt-2">
                <v-col cols="12">
                  <app-label-group label="BGP 広報ルート(Connected以外)" />
                </v-col>
              </v-row>
              <div class="ml-2">
                <v-row>
                  <v-col cols="6" class="address-title">
                    <app-badge
                      item="LANアドレス"
                      :isRequired="false"
                      :isInfo="false"
                    />
                  </v-col>
                  <v-col cols="6" class="address-title">
                    <app-badge
                      item="ネクストホップアドレス"
                      :isRequired="false"
                      :isInfo="false"
                    />
                  </v-col>
                </v-row>
                <div class="address-scroll d-flex">
                  <div class="w-50 d-flex flex-column">
                    <template v-if="sortedConnectedPairs.length">
                      <span
                        class="ml-3"
                        v-for="(pair, index) in sortedConnectedPairs"
                        :key="index"
                      >
                        {{ pair.lan }}
                      </span>
                    </template>
                    <span v-else class="ml-3">-</span>
                  </div>
                  <div class="w-50 d-flex flex-column">
                    <template v-if="sortedConnectedPairs.length">
                      <span
                        class="ml-5"
                        v-for="(pair, index) in sortedConnectedPairs"
                        :key="index"
                      >
                        {{ pair.nextHop }}
                      </span>
                    </template>
                    <span v-else class="ml-5">-</span>
                  </div>
                </div>
              </div>

              <v-row class="mt-2">
                <!--回線情報（Act）-->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>回線情報(Act)</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VNコネクト番号"
                          :value="cloudVnKcpsDetail.cloudVnConnectAct.wnumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VNコネクト名"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectAct.vnConnectName
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VLAN ID(Inner)"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectAct.vlanIdInner
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VLAN ID(Outer)"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectAct.vlanIdOuter
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="有効/無効"
                          :value="
                            $filter.enumTo(
                              cloudVnKcpsDetail.cloudVnConnectAct
                                .isVnConnectStatus,
                              'enable'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="IF状態"
                          :value="
                            $filter.enumTo(
                              cloudVnKcpsDetail.cloudVnConnectAct.ifStatus,
                              'cloudVn_ifStatus'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <!-- 回線情報（Sby） -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>回線情報(Sby)</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VNコネクト番号"
                          :value="cloudVnKcpsDetail.cloudVnConnectSby.wnumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VNコネクト名"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectSby.vnConnectName
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VLAN ID(Inner)"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectSby.vlanIdInner
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VLAN ID(Outer)"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectSby.vlanIdOuter
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="有効/無効"
                          :value="
                            $filter.enumTo(
                              cloudVnKcpsDetail.cloudVnConnectSby
                                .isVnConnectStatus,
                              'enable'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="IF状態"
                          :value="
                            $filter.enumTo(
                              cloudVnKcpsDetail.cloudVnConnectSby.ifStatus,
                              'cloudVn_ifStatus'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>

              <v-row class="mt-2">
                <!-- ルーティング情報（Act） -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>ルーティング情報(Act)</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="WANアドレス"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectAct.wanAddress
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="ピアIPアドレス"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectAct.peerIpAddress
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="プライベートIPアドレス"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectAct.privateIpAddress
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="Local Preference"
                          :value="
                            $filter.enumTo(
                              cloudVnKcpsDetail.cloudVnConnectAct
                                .localPreference,
                              'localPreference'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="MED"
                          :value="
                            $filter.enumTo(
                              cloudVnKcpsDetail.cloudVnConnectAct.med,
                              'med'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <!-- ルーティング情報（Sby） -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>ルーティング情報(Sby)</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="WANアドレス"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectSby.wanAddress
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="ピアIPアドレス"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectSby.peerIpAddress
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="プライベートIPアドレス"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectSby.privateIpAddress
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="Local Preference"
                          :value="
                            $filter.enumTo(
                              cloudVnKcpsDetail.cloudVnConnectSby
                                .localPreference,
                              'localPreference'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="MED"
                          :value="
                            $filter.enumTo(
                              cloudVnKcpsDetail.cloudVnConnectSby.med,
                              'med'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>

              <v-row class="mt-2">
                <!-- カスタム経路集約情報 -->
                <v-col cols="12">
                  <v-row>
                    <v-col>
                      <h3>カスタム経路集約情報</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="経路集約"
                          :value="
                            cloudVnKcpsDetail.cloudVnConnectCommon
                              .routeAggregation
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="
                        cloudVnKcpsDetail.cloudVnConnectCommon
                          .routeAggregation !== 'OFF'
                      "
                    >
                      <v-col>
                        <app-label-group label="経路集約アドレス">
                          <template #value>
                            <template
                              v-if="
                                cloudVnKcpsDetail.cloudVnConnectCommon
                                  .routeAggregation === 'CUSTOM'
                              "
                            >
                              <div class="d-flex flex-wrap">
                                <span
                                  class="ml-3"
                                  v-for="(
                                    ip, index
                                  ) in sortedRouteAggregationAddressList"
                                  :key="index"
                                >
                                  {{ ip }}
                                </span>
                              </div>
                            </template>
                            <template
                              v-else-if="
                                cloudVnKcpsDetail.cloudVnConnectCommon
                                  .routeAggregation === 'ON'
                              "
                            >
                              <span class="ml-3">0.0.0.0/0</span>
                            </template>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CloudVnKcpsDetailV2 } from "@/apis/CloudVnKcpsApi";
import sortCompare from "@/services/SortService";

export default defineComponent({
  name: "MultiCloudKcps3VnConnectionDeleteConfirm",
  props: {
    cloudVnKcpsDetail: {
      type: Object as PropType<CloudVnKcpsDetailV2>,
      required: true,
    },
    billingFreeFlg: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
  },
  computed: {
    /** BGP 広報ルート(ルート分割) を数値ソートした一覧 */
    sortedSplitRouteList(): string[] {
      const list =
        this.cloudVnKcpsDetail.cloudVnConnectCommon
          ?.publicRelationSplitRouteList ?? [];
      return list.sortIpAddress();
    },
    /** BGP 広報ルート(Connected以外) を LANアドレスで数値ソートしたペア一覧 */
    sortedConnectedPairs(): { lan: string; nextHop: string }[] {
      const lanList =
        this.cloudVnKcpsDetail.cloudVnConnectCommon
          ?.publicRelationConnectedExceptList;
      const nextHopList =
        this.cloudVnKcpsDetail.cloudVnConnectCommon?.publicRelationNextHopList;
      if (!lanList?.length || !nextHopList?.length) return [];
      return lanList
        .map((lan, i) => ({ lan, nextHop: nextHopList[i] ?? "" }))
        .sort((a, b) => sortCompare(a, b, [["lan", "asc"]]));
    },
    /** 経路集約アドレス（数値昇順ソート済み） */
    sortedRouteAggregationAddressList(): string[] {
      const list =
        this.cloudVnKcpsDetail.cloudVnConnectCommon
          ?.routeAggregationAddressList ?? [];
      return list.sortIpAddress();
    },
  },
});
</script>

<style lang="scss" scoped>
.address-title :deep(.badge-label) {
  font-size: 0.75rem !important;
}
.address-scroll {
  max-height: 107px;
  overflow-y: auto;
}
</style>
